import { render, staticRenderFns } from "./PublicationEdit.vue?vue&type=template&id=50215b35&scoped=true"
import script from "./PublicationEdit.vue?vue&type=script&lang=js"
export * from "./PublicationEdit.vue?vue&type=script&lang=js"
import style0 from "./PublicationEdit.vue?vue&type=style&index=0&id=50215b35&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50215b35",
  null
  
)

export default component.exports